<template>
  <v-dialog v-model="internalModel" :max-width="maxWidth" :persistent="persistent" :aria-labelledby="dialogTitleId" :aria-label="title" role="dialog">
    <v-card class="elevation-1" rounded="lg" :data-cy="dataCy">
      <v-card-title class="d-flex align-center mt-2 ml-2">
        <span :id="dialogTitleId" class="text-h6">{{ title }}</span>
        <v-spacer />
        <IconButton
          v-if="showCloseButton"
          iconName="close"
          tooltip="Close"
          @click="handleClose"
          :disabled="loading"
        />
      </v-card-title>

      <v-divider v-if="showDivider" />

      <v-card-text>
        <slot />
      </v-card-text>

      <slot name="actions" />
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useId } from 'vue'
import IconButton from './IconButton.vue'

// Generate unique ID for dialog title (for ARIA accessibility)
const dialogTitleId = useId()

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    required: true
  },
  dataCy: {
    type: String,
    default: null
  },
  maxWidth: {
    type: [String, Number],
    default: 720
  },
  persistent: {
    type: Boolean,
    default: false
  },
  showCloseButton: {
    type: Boolean,
    default: true
  },
  showDivider: {
    type: Boolean,
    default: true
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'cancel', 'close'])

const internalModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

// Handle close button click
const handleClose = () => {
  emit('cancel')
  internalModel.value = false
}

// Emit close event when dialog closes.
watch(() => props.modelValue, (isOpen) => {
  if (!isOpen) {
    emit('close')
  }
})
</script>
